import { Title } from "@vshp/ui-components";
import installmentsBg from "../../../public/images/pay.jpg";
import { LaptopIcon, PresentationIcon, RubleIcon } from "../utils/svg";
import Image from "next/image";

function Installment() {
  return (
    <section className="page__block page__block_cover page__block_center page__block_cover_white">
      <Image className="page__block-img" src={installmentsBg} alt="ЗАПЛАТИ ПО ЧАСТЯМ" />
      <div className="page__block-body">
        <Title type="h2" decor={false}>
          ЗАПЛАТИ ПО ЧАСТЯМ
        </Title>

        <div className="installment-info">
          <div className="installment-info__item">
            <div className="installment-info__icon">
              <LaptopIcon />
            </div>
            <div className="installment-info__title t-h3">Всё онлайн</div>
          </div>
          <div className="installment-info__item">
            <div className="installment-info__icon">
              <PresentationIcon />
            </div>
            <div className="installment-info__title t-h3">1 месяц без переплат</div>
          </div>
          <div className="installment-info__item">
            <div className="installment-info__icon">
              <RubleIcon />
            </div>
            <div className="installment-info__title t-h3">Удобное погашение</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Installment;
